import React, { useState, useEffect } from 'react';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import PriceSummarySection from '../Constans/PriceSummarySection/PriceSummarySection';
import TextInput from 'app/Components/Shared/TextInput/TextInput';
import { GetCreditCardTypeId, formatActivityHours } from '../IdfSaleEnums';
import usePageCapture from '../../../../utilities/hooks/usePageCapture';
import useSaveToCalender from '../../../../utilities/hooks/useSaveToCalender';
import BtnWhiteBlackBorderSmallSize from '../../../Shared/Buttons/BtnWhiteBlackBorderSmallSize';
import { validateInput } from '../Constans/Validation';
import EpiContext from '@episerver/spa-core/Spa';
import { INPUT_TYPE } from '../IdfSaleEnums';
import ErrorPage from '../PopUps/ErrorPage';
import Buttons from '../Constans/Buttons';
import Config from 'app/Config';
import OrderSummarySucceededButton from './OrderSummarySucceededButton';
const OrderSummaryPhoneUpgrade = (props) => {
  console.log(props);
  const [mailError, setMailError] = useState(null);
  const { idfStore: store } = props;
  const [isSubmitSuccess, setIsSubmitSuccess] = useState(null);
  const [insertOrderErr, setInsertOrderErr] = useState(null);

  const { captureRef, capturePage } = usePageCapture();

  useEffect(() => {
    if (props.isSubmitSuccess) {
      setIsSubmitSuccess(true);
    }
  }, []);

  useEffect(() => {
    if (isSubmitSuccess && typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }
  }, [isSubmitSuccess]);

  const convertDateTime = (date) => {
    let timeFormat;
    if (!props.isExistedOrder) {
      const dateObject = new Date(date);
      const hours = dateObject.getUTCHours().toString().padStart(2, '0');
      const minutes = dateObject.getUTCMinutes().toString().padStart(2, '0');
      timeFormat = `${hours}:${minutes}`;
      return timeFormat;
    } else {
      const [datePart, timePart] = date.split(' ');
      const [hours, minutes] = timePart.split(':');
      timeFormat = `${hours}:${minutes}`;
      return timeFormat;
    }
  };

  const onSubmit = async () => {
    //validate Email
    const mailError = validateInput(store.selectedEmail, INPUT_TYPE.EMAIL);
    if (mailError) {
      const res = await props.onFinalSubmit();
      if (res.payload.isSuccess) {
        setIsSubmitSuccess(true);
      } else {
        setInsertOrderErr(res.payload.codeError);
        setIsSubmitSuccess(false);
      }
    } else {
      setMailError('יש להזין כתובת מייל תקנית');
    }
  };
  const totalPrice = store?.selectedPhone?.totalPrice;
  const productsArr = [
    store.processType === 'DEVICE' && {
      name: store.selectedPhone.groupName + 'GB',
      price: parseFloat(totalPrice).toFixed(2),
      monthlyPrice: parseFloat((totalPrice / parseInt(store.selectedPhone.selectedPayment, 10)).toFixed(2)),
      payments: parseInt(store.selectedPhone.selectedPayment, 10),
      monthly: true,
    },
  ];

  const { user_type_id: userType } = props.idfStore.userDetails;
  const warrantyPrice = props.contentData?.warrantyPrice.value || store.warrantyPrice;
  const warrantyPriceToInt = userType === 'Regular' ? Math.round(parseFloat(warrantyPrice) * 100) / 100 : 0;
  const paymentType = store.selectedPhone.paymentType == "OUTINVOICE" ? 'תשלום בנפרד מהחשבונית' : 'תשלום חודשי בחשבונית';


  const monthlyProductsArr = [];
  store.selectedPhone?.insuranceOption === 'ADD_INSURANCE' &&
    monthlyProductsArr.push({
      name: 'שירות תיקונים בסיסי',
      price: warrantyPriceToInt,
      monthly: false,
    });

  const deliveryAddressInfo = store.deliverySelectedAddress;
  const deliveryDate = !props.isExistedOrder
    ? new Date(store.selectedDeliverySlot?.deliveryStartTime).toLocaleDateString('en-GB')
    : store.selectedDeliverySlot?.deliveryStartTime?.split(' ')[0];
  const deliveryInfo = store.deliveryMode === 'DELIVERY' && {
    deliveryHebrewDayOfTheWeek: store.selectedDeliverySlot.hebrewDayName,
    deliveryDate: deliveryDate,
    deliveryRange: [
      convertDateTime(store.selectedDeliverySlot.deliveryStartTime),
      convertDateTime(store.selectedDeliverySlot.deliveryEndTime),
    ],
    address: `${deliveryAddressInfo.streetName + ' ' + deliveryAddressInfo.home} ,${deliveryAddressInfo.entry !== ' ' ? deliveryAddressInfo.entry + ',' : ''
      } דירה ${deliveryAddressInfo.apartment},  ${deliveryAddressInfo.cityName}`,
    recipientName: store.deliverySelectedFirstName + ' ' + store.deliverySelectedLastName,
    recipientPhoneNumber: store.deliverySelectedPhoneNumber,
  };
  const handleAddToCalenderClick = () => {
    const calendarSettings = {
      deliverySlots: store.selectedDeliverySlot,
    };
    useSaveToCalender(calendarSettings);
  };

  function PriceInformation(props) {
    return (
      <div className='price-information-container'>
        <span className='main-title'>{props.title}</span>
        <div className='products-container'>
          {props.subTitle && <span className='sub-title'>{props.subTitle}</span>}
          {props.arr.map((p) => (
            <div className='product-container'>
              <div className='full-price'>
                <span className='name'>{p.name}</span>
                <span className='price'>{'₪' + p.price}</span>
              </div>
              {p.monthly && (
                <span className='monthly-price' dir='ltr'>
                  {` ${p.payments} X  ₪${p.monthlyPrice} `}
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  }
  function TotalPrice(props) {
    return (
      <div className='total-price-container'>
        <span>{props.title}</span>
        <span>₪{props.totalPrice}</span>
      </div>
    );
  }
  function getTotalPrice(Arr) {
    let totalPrice = 0;
    Arr.forEach((element) => {
      const priceToInt = parseFloat(parseFloat(element.price).toFixed(2));
      totalPrice += priceToInt;
    });
    return totalPrice;
  }

  function createDom() {
    return <>
      {isSubmitSuccess == false ? (
        <>
          <ErrorPage errorCode={insertOrderErr} />
        </>
      ) :
        <div className='main-container step' dir='rtl' ref={captureRef}>
          <div className='order-summary-container'>
            {isSubmitSuccess == null ? (
              <>
                <div className='title-container'>
                  <span className='main-title'>סיכום פרטי ההזמנה</span>
                  <div className='divider'></div>
                  <span className='sub-title'>האם כל הפרטים נכונים?</span>
                </div>
              </>

            ) : (
              <>
                <div className='title-container'>
                  <span className='main-title'> ההזמנה בוצעה בהצלחה!</span>
                  {store.deliveryMode === 'DELIVERY' && (
                    <>
                      <span className='sub-title'>
                        {' '}
                        נפגש ב{deliveryInfo.deliveryHebrewDayOfTheWeek}, {deliveryInfo?.deliveryDate} בין {deliveryInfo?.deliveryRange[0]}-
                        {deliveryInfo?.deliveryRange[1]}
                      </span>
                    </>
                  )}
                </div>
              </>
            )}

            <div className='divider'></div>

            {store.processType === 'DEVICE' && (
              <PriceInformation title={'חיוב בגין ציוד'} subTitle={'מוצרים'} arr={productsArr}></PriceInformation>
            )}
            {store.processType === 'DEVICE' && (
              <TotalPrice title={'סה״כ חיוב בגין ציוד'} totalPrice={parseFloat(totalPrice).toFixed(2)}></TotalPrice>
            )}
            {(getTotalPrice(monthlyProductsArr) > 0) &&
              <>
                <div className='divider'></div>
                <PriceInformation title={'חיובים חודשיים'} subTitle={''} arr={monthlyProductsArr}></PriceInformation>
                <TotalPrice title={'סה״כ חיוב חודשי'} totalPrice={getTotalPrice(monthlyProductsArr)}></TotalPrice>
              </>
            }
            <div className='divider'></div>
            <PriceSummarySection title='אופן התשלום' />
            <div className='info'><span className='detail'>
              {paymentType}
            </span>
            </div>
            <div className='divider'></div>
            <PriceSummarySection title='קבלת הזמנה' />
            {store.deliveryMode === 'DELIVERY' ? (
              <div className='info'>
                <span className='detail'>
                  השליח יגיע ב{deliveryInfo.deliveryHebrewDayOfTheWeek}, {deliveryInfo?.deliveryDate} בין {deliveryInfo?.deliveryRange[0]}-
                  {deliveryInfo?.deliveryRange[1]}
                </span>
                <span className='detail'>לכתובת {deliveryInfo?.address}</span>
                {!store.isSimInMailBox && (
                  <span className='detail'>
                    יקבל את השליח {deliveryInfo?.recipientName} {deliveryInfo.recipientPhoneNumber}
                  </span>
                )}
              </div>
            ) : (
              <div className='info'>
                <span className='detail'>{store?.pickupServiceCenter?.service_center_name}</span>
                <span className='detail'>{store.pickupServiceCenter?.service_center_location}</span>
                {store.pickupServiceCenter?.activity_hours && (
                  <span className='detail'>{formatActivityHours(store.pickupServiceCenter?.activity_hours)}</span>
                )}
              </div>
            )}
            {/* </>
          )} */}
            {isSubmitSuccess != true ? (
              <>
                <div className='divider'></div>
                <span className='field-title'>לאיזה דוא"ל לשלוח את סיכום ההזמנה?</span>
                <TextInput
                  onChange={(e) => props.setSelectedEmail(e.target.value)}
                  type='email'
                  placeholder='דואל'
                  name='mailAddress'
                  value={store.selectedEmail}
                  error={mailError}
                  required={true}
                />
                {props.onFinalSubmit &&
                  <Buttons
                    onClickNavigation={onSubmit}
                    btnContinueText='אישור וסיום'
                    canContinue={true}
                  />}
              </>
            ) : (
              <>
                <div className='divider'></div>
                <PriceSummarySection title='סיכום ההזמנה נשלח לדוא"ל' />
                <div className='info'>
                  <span className=''>{store.selectedEmail}</span>
                </div>
                <div className='action-btns-container'>
                  <BtnWhiteBlackBorderSmallSize text='שמירה כתמונה' onclick={capturePage} />
                  {store.deliveryMode === 'DELIVERY' && (
                    <BtnWhiteBlackBorderSmallSize text='הוספת תזכורת ליומן' onclick={handleAddToCalenderClick} />
                  )}
                </div>
                {/* return to idfLObby? */}
                {store.isSaleDone && (
                  <OrderSummarySucceededButton />
                )}
              </>
            )}
          </div>
        </div>}</>

  }
  return createDom();
};

export default OrderSummaryPhoneUpgrade;
